var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.update($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm.isItemFound()
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("input-email", {
                          attrs: {
                            options: {
                              id: "billingEmail",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "billing_email",
                              error: _vm.fieldErrors.billingEmail
                            }
                          },
                          model: {
                            value: _vm.billingEmail,
                            callback: function($$v) {
                              _vm.billingEmail = $$v
                            },
                            expression: "billingEmail"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "vatNumber",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "vat_number",
                              error: _vm.fieldErrors.vatNumber
                            }
                          },
                          model: {
                            value: _vm.vatNumber,
                            callback: function($$v) {
                              _vm.vatNumber = $$v
                            },
                            expression: "vatNumber"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "zipCode",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "zip_code",
                              error: _vm.fieldErrors.zipCode
                            }
                          },
                          model: {
                            value: _vm.zipCode,
                            callback: function($$v) {
                              _vm.zipCode = $$v
                            },
                            expression: "zipCode"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "poBox",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "po_box",
                              error: _vm.fieldErrors.poBox
                            }
                          },
                          model: {
                            value: _vm.poBox,
                            callback: function($$v) {
                              _vm.poBox = $$v
                            },
                            expression: "poBox"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "addressLine1",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "address_line_1",
                              error: _vm.fieldErrors.addressLine1
                            }
                          },
                          model: {
                            value: _vm.addressLine1,
                            callback: function($$v) {
                              _vm.addressLine1 = $$v
                            },
                            expression: "addressLine1"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "addressLine2",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "address_line_2",
                              error: _vm.fieldErrors.addressLine2
                            }
                          },
                          model: {
                            value: _vm.addressLine2,
                            callback: function($$v) {
                              _vm.addressLine2 = $$v
                            },
                            expression: "addressLine2"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: { to: { name: _vm.routePrefix + ".show" } }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _vm.isItemFound()
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { type: "submit", disabled: _vm.loading }
                            },
                            [
                              _vm.loading
                                ? _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm"
                                  })
                                : _vm._e(),
                              _c("i", { staticClass: "fa fa-save" })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }